export default {
    workOrder_driverSelector_title: "Seleccionar Conductor",
    workOrder_driverSelector_scheduledAt: "Programado Para",
    workOrder_driverSelector_driver: "Conductor",
    workOrder_driverSelector_unit: "Unidad",
    workOrder_driverSelector_unassigned: "Sin Asignar",
    workOrder_driverSelector_driversAvailable: "Conductores disponibles en en el rango seleccionado",
}